package nl.volleyplanner.util

import kotlinx.datetime.LocalDate
import kotlinx.datetime.Month

object SeasonUtil {
    private val SEASON_CUTOFF_MONTH = Month.JUNE

    /**
     * Generates a list of season names between the given start and end dates.
     * Season cut-off is at the end of June.
     *
     * @param startDate The start date (inclusive)
     * @param endDate The end date (inclusive)
     * @return List of season names in format "YYYY-YYYY"
     */
    fun generateSeasonNames(startDate: LocalDate, endDate: LocalDate): List<String> {
        val startYear = if (startDate.month <= SEASON_CUTOFF_MONTH) startDate.year - 1 else startDate.year
        val endYear = if (endDate.month <= SEASON_CUTOFF_MONTH) endDate.year - 1 else endDate.year

        return (startYear..endYear).map { year -> "${year}-${year + 1}" }
    }

    /**
     * Gets the season name for a specific date.
     *
     * @param date The date to get the season for
     * @return Season name in format "YYYY-YYYY"
     */
    fun getSeasonName(date: LocalDate): String {
        val seasonStartYear = if (date.month <= SEASON_CUTOFF_MONTH) date.year - 1 else date.year
        return "${seasonStartYear}-${seasonStartYear + 1}"
    }
}
